var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:'label label-'+(_vm.data.style)},[_vm._v(_vm._s(_vm.data.label))])}
var staticRenderFns = []

export { render, staticRenderFns }